import React from 'react';
import styled from 'styled-components';
import { Box, Heading } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { useOnboarder } from '../../components/Onboarder/OnboarderContext';
import { AnswerLink } from '../../components/Step/AnswerLink';
import { createStepSummaries } from '../../components/Step/createStepSummaries';
import type { Data } from '../config';

const StyledHeading = styled(Heading)`
    color: ${(props) => (props.color ? props.color : colors.grey800)};
`;

const Text = styled.p`
    color: ${colors.grey700};
    max-width: 900px;
`;

export function RecommendationSummary() {
    const { config, data } = useOnboarder<Data>();
    const stepSummaries = createStepSummaries(config, data);

    return (
        <>
            <StyledHeading accessibilityLevel={7} appearanceLevel={5}>
                {__('Your recommendation is based on these details:')}
            </StyledHeading>
            <Box marginTop="1bu">
                <Text>
                    {/* eslint-disable-next-line array-callback-return */}
                    {stepSummaries.map((stepSummary) => {
                        if (!stepSummary.hideIfEmpty) {
                            return (
                                <span key={stepSummary.link}>
                                    <FormattedMessage
                                        message={stepSummary.question}
                                        values={{
                                            answer: (
                                                <AnswerLink href={stepSummary.link}>
                                                    {stepSummary.answer}
                                                </AnswerLink>
                                            ),
                                        }}
                                    />
                                    {localisedPeriod() + ' '}
                                </span>
                            );
                        }
                    })}
                </Text>
            </Box>
        </>
    );
}

function localisedPeriod(): string {
    const locale = 'en';
    switch (locale) {
        case 'en':
            return '.';
        default:
            return '.';
    }
}
